// import React, { useContext, useState ,useEffect } from 'react'
// import { AppContext } from '../../App'
// import 'react-toastify/dist/ReactToastify.css';
// import ReactPlayer from 'react-player';
// import './active.css'

// const Activities = () => {
//     const {route,setLoader ,imgRoute}=useContext(AppContext)
//     const [articles ,setArticles]=useState([])

//     useEffect(()=>{
//         fetch(`${route}/events`)
//         .then(res=>res.json())
//         .then(data=>{
//           if(data.data){
//             setArticles(data.data)
         
//           }
//         })
//       },[])
//   return (
//    <div className="activities">
//     <div className="container">
//     <h1>الفعاليات</h1>
// <div className="active-cont">
// {articles.map((art,index)=>{
//               return(
//                 <div className="article-card" key={index}>
//                   <div className="title">{art.title}</div>
//                   <div className="desc">{art.desc}</div>
//                   {art.content.includes("http") ? 
//                        <ReactPlayer
//                        url={art.content}
//                        controls={true}
//                        width="100%"
//                        height="100%"
//                      />
//                   : <img src={`${imgRoute}/${art.content}`} />}
                
//                 </div>
//               )
//             })}
// </div>
//     </div>
//    </div>
//   )
// }

// export default Activities

import React, { useContext, useState, useEffect } from "react";
import { AppContext } from "../../App";
import ReactPlayer from "react-player";
import "./active.scss";

const SkeletonCard = () => (
  <div className="article-card skeleton">
    <div className="sk-title"></div>
    <div className="sk-desc"></div>
    <div className="sk-media"></div>
  </div>
);

const Activities = () => {
  const { route, imgRoute } = useContext(AppContext);
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${route}/events` , {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${sessionStorage.getItem("token")}`
      }
    })
      .then((res) => res.json())
      .then((data) => {
        setArticles(data.data || []);
        setLoading(false);
      });
  }, []);

  return (
    <div className="activities-page">
      <div className="activities-container">
        <h2>الفعاليات</h2>

        <div className="activities-grid">
          {loading
            ? Array.from({ length: 3 }).map((_, i) => (
                <SkeletonCard key={i} />
              ))
            : articles.map((art, index) => (
                <div className="article-card" key={index}>
                  <h3>{art.title}</h3>
                  <p>{art.desc}</p>

                  <div className="media">
                    {art.content?.includes("http") ? (
                      <ReactPlayer
                        url={art.content}
                        controls
                        width="100%"
                        height="100%"
                      />
                    ) : (
                      <img
                        src={`${imgRoute}/${art.content}`}
                        alt={art.title}
                      />
                    )}
                  </div>
                </div>
              ))}
        </div>
      </div>
    </div>
  );
};

export default Activities;
